import { motion } from "framer-motion";
import { BedDouble, CookingPot, Leaf, ShowerHead } from "lucide-react";
import ChapterHeading from "@/components/landing/ChapterHeading";

const SPACES = [
  {
    icon: BedDouble,
    title: "La Camera",
    img: "/photos/camera_pro.webp",
    text: "Letto matrimoniale sotto le travi antiche, presa elettrica vicino al letto, TV e il silenzio del borgo.",
  },
  {
    icon: CookingPot,
    title: "La Cucina",
    img: "/photos/cucina_pro.webp",
    text: "Piano cottura, forno e utensili: tutto il necessario per cucinare i prodotti dell'Umbria.",
  },
  {
    icon: ShowerHead,
    title: "Il Bagno",
    img: "/photos/bagno_pro.webp",
    text: "Bagno privato con doccia, bidet e asciugamani inclusi. Semplice, pulito, tutto vostro.",
  },
  {
    icon: Leaf,
    title: "Il Giardino",
    img: "/photos/giardino_pro.webp",
    text: "Prato, amaca e sedie all'ombra tra le mura secolari: il vostro angolo di pace all'aria aperta.",
  },
];

export default function Spazi() {
  return (
    <section id="spazi" data-testid="spazi-section" className="bg-[#EEF1E6] py-24 sm:py-36">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <ChapterHeading
          eyebrow="Capitolo 02"
          title="Gli Spazi"
          subtitle="Una camera, una cucina, un bagno e un giardino segreto: pochi ambienti, pensati bene. Ogni dettaglio al suo posto."
        />

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {SPACES.map((s, i) => (
            <motion.article
              key={s.title}
              data-testid={`space-card-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="group bg-linen"
            >
              <div className="overflow-hidden rounded-sm">
                <img
                  src={s.img}
                  alt={s.title}
                  loading="lazy"
                  className="aspect-[4/5] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
                />
              </div>
              <div className="p-6">
                <div className="mb-3 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-terracotta/10 text-terracotta">
                    <s.icon size={18} />
                  </span>
                  <h3 className="font-serif text-xl text-stone-800 sm:text-2xl">{s.title}</h3>
                </div>
                <p className="text-sm font-light leading-relaxed text-stone-600">{s.text}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
